import React from "react";

const Details = ({ title, subTitle, episodeInfo }) => {
  return (
    <div className="details">
      {title && title !== "" ? <span className="title"> {title} </span> : null}
      {subTitle && <span className="description"> {subTitle} </span>}
      {episodeInfo && <div className="description">{episodeInfo}</div>}
    </div>
  );
};

export default Details;
